<template>
  <div class="bg">
    <div>
      <el-form  label-width="120px" :model="dataInfo" :label-suffix="' :'">
        <el-form-item label="类型">
          <span>{{dataInfo.serviceType == 'enterprise' ? '企业' : '个人'}}</span>
        </el-form-item>
        <el-form-item label="营业执照" v-if="dataInfo.serviceType == 'enterprise'">
          <el-image
              style="width: 106px; height: 106px"
              :z-index="3000"
              :src="dataInfo.licenseImg"
              :preview-src-list="[dataInfo.licenseImg]">
          </el-image>
        </el-form-item>
        <el-form-item label="名称" v-if="dataInfo.serviceType == 'enterprise'">
          <span>{{dataInfo.storeName}}</span>
        </el-form-item>
        <el-form-item label="社会信用代码" v-if="dataInfo.serviceType == 'enterprise'">
          <span>{{dataInfo.industryCode}}</span>
        </el-form-item>
        <el-form-item label="经营期限" v-if="dataInfo.serviceType == 'enterprise'">
          <span>{{moment(dataInfo.licenseDueDate).format("YYYY-MM-DD")}}</span>
        </el-form-item>
        <el-form-item label="授权书" v-if="dataInfo.serviceType == 'enterprise' && dataInfo.authBookImg">
          <el-image
              style="width: 106px; height: 106px"
              :z-index="3000"
              :src="dataInfo.authBookImg"
              :preview-src-list="[dataInfo.authBookImg]">
          </el-image>
        </el-form-item>
        <el-form-item label="身份证正反面">
          <div class="flex flex-between" style="width: 45%">
            <el-image
                :z-index="3000"
                v-if="dataInfo.idcardFrontImg"
                style="width: 106px; height: 106px"
                :src="dataInfo.idcardFrontImg"
                :preview-src-list="[dataInfo.idcardFrontImg]">
            </el-image>
            <el-image
                :z-index="3000"
                v-if="dataInfo.idcardBackImg"
                style="width: 106px; height: 106px"
                :src="dataInfo.idcardBackImg"
                :preview-src-list="[dataInfo.idcardBackImg]">
            </el-image>
          </div>
        </el-form-item>
        <el-form-item label="姓名">
          <span>{{dataInfo.idcardName}}</span>
        </el-form-item>
        <el-form-item label="证件号码">
          <span>{{dataInfo.idcardNo}}</span>
        </el-form-item>
        <el-form-item label="证件有效期">
          <span>{{moment(dataInfo.idcardStartDate).format("YYYY-MM-DD") + ' - ' + moment(dataInfo.idcardEndDate).format("YYYY-MM-DD")}}</span>
        </el-form-item>
        <el-form-item label="手机号">
          <span>{{dataInfo.contactPhone}}</span>
        </el-form-item>
        <el-form-item label="邮箱">
          <span>{{dataInfo.contactEmail}}</span>
        </el-form-item>
        <el-form-item label="基础分成比例" v-if="auditType == 'agent'">
          <span class="warn-ms">{{dataInfo.profitRatio}}</span>%
          <span class="ml10" style="color: #909399; font-size: 12px">
            从平台利润中分给代理商的收益，计算公式为每笔平台收入*分成比例
          </span>
        </el-form-item>
        <el-form-item label="服务费比例" v-if="auditType == 'supplier'">
          <span class="warn-ms">{{dataInfo.percentageRatio}}%</span>
        </el-form-item>
        <el-form-item label="最低服务费" v-if="auditType == 'supplier'">
          <span class="warn-ms">{{dataInfo.nadirMoney}}元</span>
        </el-form-item>
        <el-form-item label="余额预警" v-if="auditType == 'supplier'">
          <span class="warn-ms">{{dataInfo.balanceNoticeLine}}元</span>
        </el-form-item>
      </el-form>
    </div>
    <div class="mt40" v-if="showAudit">
      <el-form  label-width="120px" ref="auditForm" :model="auditData" >
        <el-form-item label="审批结果">
          <el-radio-group v-model="auditData.status">
            <el-radio :label="'yes'">审批通过</el-radio>
            <el-radio :label="'no'">审批不通过</el-radio>
          </el-radio-group>
          <div class="mt10" v-if="auditData.status == 'no'">
            <el-input type="textarea" placeholder="请填写拒绝原因"  v-model="auditData.desc"></el-input>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "HmRedPacgageAudit",
  props: {
    showAudit: {
      type: Boolean,
      default: true
    },
    auditType: {type: String},
    id: {type: String},
    formPath: {type: String},
    row: {type: Object}
  },
  data() {
    return {
      moment,
      dataInfo: {},
      auditData: {
        status: "yes"
      }
    }
  },
  created() {
    this.queryList();
  },
  mounted() {

  },
  methods: {
    //查询数据
    queryList() {
      if (this.formPath == 'audit') {
        this.queryAuditInfo();
      } else if (this.formPath == 'manage') {
        this.queryManageInfo();
      }
    },
    async queryAuditInfo() {
      const {result} = await this.$store.dispatch("queryServiceProviderExpandInfoModel", {id: this.id});
      console.log("result",result);
      this.dataInfo = result;
    },
    async queryManageInfo() {
      this.dataInfo = this.row;
    }

  }
}
</script>

<style scoped lang="scss">
.bg {
  background: #fff;
}
.warn-ms {
  color: #FF0000;
}
</style>